(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-carousel]').forEach(track => {
      if (track.dataset.ready) return;
      track.dataset.ready = 'true';
      const controls = track.parentElement.querySelector('[data-carousel-controls]');
      if (!controls) return;
      const sync = () => {
        controls.hidden = track.scrollWidth <= track.clientWidth + 2;
        controls.querySelector('[data-scroll="-1"]').disabled = track.scrollLeft < 2;
        controls.querySelector('[data-scroll="1"]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      controls.addEventListener('click', event => {
        const button = event.target.closest('[data-scroll]');
        if (button) track.scrollBy({left: Number(button.dataset.scroll) * track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
      track.addEventListener('scroll', sync, {passive:true});
      const observer = new ResizeObserver(sync);
      observer.observe(track);
      track._resizeObserver = observer;
      sync();
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.site-header details[open]');
    if (open) {open.open = false; open.querySelector('summary').focus();}
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.site-header details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-carousel]').forEach(track => track._resizeObserver?.disconnect()));
  init();
})();
